<template>
  <div>
    <el-popconfirm
      :title="$t('orders.tip.danger')"
      :ref="`popover-${row.id}-2-2`"
      @confirm="getManual()"
      :key="`${row.id}-2-2`"
    >
      <el-button size="mini" type="danger" slot="reference">{{ $t('btns.manual') }}</el-button>
    </el-popconfirm>
    <el-dialog :visible.sync="validCard">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item :label="$t('accountmanager.inputtext')" prop="submitAmount">
          <el-input v-model="form.submitAmount" size="mini"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orders.tip.googleCode')" prop="patchGoogleCode">
          <el-input v-model="form.patchGoogleCode" maxlength="6" size="mini"></el-input>
        </el-form-item>
      </el-form>

      <div class="">
        <el-button type="primary" @click="handleValid" size="mini" class="confirm-btn">{{
          $t('btns.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ordersApi from '@/api/orders';

export default {
  props: {
    row: {
      type: Object
    }
  },
  data() {
    return {
      validCard: false,
      form: { submitAmount: '', patchGoogleCode: '' },
      receipt: ''
    };
  },
  computed: {
    rules() {
      return {
        submitAmount: { required: true, message: this.$t('accountmanager.inputtext') },
        patchGoogleCode: {
          validator: (rule, value, callback) => {
            if (!value.match('^[0-9]{6}$')) {
              callback(new Error(this.$t('merchantdeposit.rules.googleDynamicCaptcha.max')));
            } else {
              callback();
            }
          }, trigger: 'blur'
        }
      };
    }
  },
  methods: {
    getManual() {
      this.validCard = true;
    },
    handleValid() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { data } = await ordersApi.getCardPcManual({
            systemOrderNo: this.row.systemOrderNo,
            ...this.form
          });
          if (data) {
            if (data.code === 200) {
              this.$message({
                type: 'success',
                message: `${this.$t('status.success6')}:${this.form.submitAmount}`
              });
              this.validVcb = false;
              this.$emit('getTable');
            } else {
              this.$message.error(data.msg);
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm-btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/orders/card-dialog.vue